import { ApiError } from '@/lib/api';

/**
 * The ONE wording of the three credit-note city refusals (owner 2026-10-27),
 * used by the raise flow, the copy-from-invoice dialog and the credit-note line
 * grid. Matched on `code`, never on the status or the message: the 409 and the
 * two 422s each say something different. `null` = not a city refusal.
 */
export function creditCityRefusalMessage(caught: unknown): string | null {
  if (!(caught instanceof ApiError)) return null;
  switch (caught.code) {
    case 'CREDIT_NOTE_CITY_ALREADY_CREDITED':
      return 'One or more of these cities has already been credited on another credit note.';
    case 'CREDIT_NOTE_CITY_NOT_ON_LINE':
      return 'One or more of these cities is not on that invoice line.';
    case 'CREDIT_NOTE_CITIES_NEED_INVOICE_LINE':
      return 'Cities can only be credited on a line copied from an invoice.';
    default:
      return null;
  }
}

/**
 * A copy-from-invoice failure as a sentence: the city refusals in our own
 * wording ({@link creditCityRefusalMessage}); every other refusal keeps the
 * server's own wording.
 */
export function creditCopyErrorMessage(caught: unknown): string {
  const cityRefusal = creditCityRefusalMessage(caught);
  if (cityRefusal !== null) return cityRefusal;
  if (caught instanceof ApiError) return caught.formMessage ?? caught.message;
  return caught instanceof Error ? caught.message : 'The request failed.';
}
